import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styled from 'styled-components';
import { NAVIGATION_ITEMS } from '@/constants/navigation';
import { Button as LegartaButton, Navigation as LegartaNavigation } from '@/ui';
import { colors } from '@/theme/colors';
export const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };
    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };
    const handleItemClick = (key) => {
        closeMobileMenu();
    };
    return (_jsxs(HeaderContainer, { children: [_jsxs(HeaderContent, { children: [_jsx(Logo, { children: _jsx(Link, { to: "/", onClick: closeMobileMenu, children: _jsx(LogoImage, { src: "/assets/logo.png", alt: "Legarta - \u041E\u0442\u0434\u0435\u043B\u043E\u0447\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B" }) }) }), _jsx(Navigation, { className: "desktop-nav", children: _jsx(LegartaNavigation, { items: NAVIGATION_ITEMS, selectedKey: location.pathname, mode: "horizontal", onItemClick: handleItemClick }) }), _jsx(HeaderActions, { children: _jsx(LegartaButton, { variant: "primary", size: "medium", children: "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A" }) }), _jsx(MobileMenuToggle, { className: "mobile-menu-toggle", onClick: toggleMobileMenu, children: mobileMenuOpen ? '✕' : '☰' })] }), _jsxs(MobileMenu, { isOpen: mobileMenuOpen, children: [_jsx(MobileNavigation, { children: _jsx(LegartaNavigation, { items: NAVIGATION_ITEMS, selectedKey: location.pathname, mode: "vertical", onItemClick: handleItemClick }) }), _jsx(MobileActions, { children: _jsx(LegartaButton, { variant: "primary", size: "large", block: true, children: "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A" }) })] })] }));
};
const HeaderContainer = styled.header `
  background: ${colors.backgroundPrimary};
  box-shadow: 0 2px 8px ${colors.shadowLight};
  position: sticky;
  top: 0;
  z-index: 1000;
`;
const HeaderContent = styled.div `
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;

  @media (max-width: 1024px) {
    padding: 0 16px;
  }

  @media (max-width: 768px) {
    height: 64px;
    padding: 0 16px;
  }

  @media (max-width: 480px) {
    padding: 0 12px;
  }
`;
const Logo = styled.div `
  a {
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
    outline: none;
    
    &:focus {
      outline: none;
    }
    
    &:focus-visible {
      outline: none;
    }
  }
`;
const LogoImage = styled.img `
  height: 50px;
  width: auto;
  max-width: 250px;
  outline: none;
  
  &:focus {
    outline: none;
  }
  
  &:focus-visible {
    outline: none;
  }

  @media (max-width: 768px) {
    height: 40px;
    max-width: 200px;
  }

  @media (max-width: 480px) {
    height: 35px;
    max-width: 180px;
  }
`;
const Navigation = styled.nav `
  flex: 1;
  margin: 0 48px;

  @media (max-width: 1024px) {
    margin: 0 24px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
const HeaderMenu = styled.div `
  background: transparent;
  border: none;
  line-height: 78px;
`;
const SubMenu = styled.div `
  padding: 12px 20px;
  line-height: 1.5;
`;
const HeaderActions = styled.div `
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;
const MobileMenuToggle = styled.button `
  display: none;
  background: transparent;
  border: none;
  font-size: 20px;
  color: ${colors.textSecondary};
  cursor: pointer;
  padding: 8px;

  @media (max-width: 768px) {
    display: block;
  }
`;
const MobileMenu = styled.div `
  display: ${props => props.isOpen ? 'block' : 'none'};
  background: ${colors.backgroundPrimary};
  padding: 24px;
  box-shadow: 0 4px 12px ${colors.shadowLight};

  @media (max-width: 480px) {
    padding: 16px;
  }
`;
const MobileNavigation = styled.nav `
  margin-bottom: 24px;
`;
const MobileMenuItems = styled.div `
  background: transparent;
  border: none;
`;
const MobileActions = styled.div `
  padding-top: 16px;
`;
